export default {
  setFilterForPreTestReserving(context, filterData) {
    context.commit('setTestFilter', {
      testTypeID: filterData.testTypeID,
      sessionTypeID: filterData.sessionTypeID,
    });
  },
  setFilterForPreReserving(context, filterData) {
    context.commit('setFilter', {
      therapyTypeID: filterData.therapyTypeID,
      sessionTypeID: filterData.sessionTypeID,
      scopeIDs: filterData.scopeIDs,
    });
  },
  removeFilterForPreTestReserving(context) {
    context.commit('removeTestFilter');
  },
  removeFilterForPreReserving(context) {
    context.commit('removeFilter');
  },
  setSessionForReplacement(context, sessionData) {
    sessionStorage.setItem('replacedSessionData', JSON.stringify(sessionData));
    context.commit('setReplacedSessionData', sessionData);
  },
  removeSessionForReplacement(context) {
    sessionStorage.removeItem('replacedSessionData');
    context.commit('removeReplacedSessionData');
  },
};
